//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['companySum'],
  methods: {
    format_date(timeStamp) {
      const time = new Date(timeStamp * 1000);
      const y = time.getFullYear();
      const m = time.getMonth() + 1;
      const d = time.getDate();
      return y + '-' + m + '-' + d;
    },
  },
};
